import {
  Component,
  ElementRef,
  Input,
  Renderer2,
  ViewChild,
} from "@angular/core";

@Component({
  selector: "expandable",
  templateUrl: "expandable.html",
})
export class ExpandableComponent {
  @ViewChild("expandWrapper", { read: ElementRef }) expandWrapper;
  expanded = false;

  @Input() btnId: string;

  constructor(public renderer: Renderer2) {}

  ngAfterViewInit() {
    this.renderer.setStyle(
      this.expandWrapper.nativeElement,
      "height",
      "inherit"
    );
  }

  viewMore() {
    this.expanded = !this.expanded;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/expandable/expandable.ts